<template>
  <div>
    <div class="container">
      <div class="tem_title">基本信息</div>
      <div class="box flex_wrap">
        <div style="margin-bottom: 16px">
          <span class="title">最后登录时间</span>
          <span>{{ info.deviceid_msg.timestamp }}</span>
        </div>
        <div>
          <span class="title">最后登录地址</span>
          <span
            >{{ info.deviceid_msg.province_name
            }}{{ info.deviceid_msg.city_name }}</span
          >
        </div>
        <div>
          <span class="title">APP版本号</span>
          <span>{{ info.deviceid_msg.version }}</span>
        </div>
        <div>
          <span class="title">设备名称</span>
          <span>{{ info.deviceid_msg.device_name }}</span>
        </div>
        <div>
          <span class="title">设备型号</span>
          <span>{{ info.deviceid_msg.device_model }}</span>
        </div>
        <div>
          <span class="title">系统版本</span>
          <span>{{ info.deviceid_msg.system_version }}</span>
        </div>
        <div style="margin-top: 16px">
          <span class="title">绑定歧黄助手</span>
          <template v-if="info.wx_openid">
            <span style="margin-right: 10px">{{
              info.wx_nick_name ? info.wx_nick_name : "已绑定"
            }}</span>
            <el-button
              type="primary"
              size="mini"
              @click="unbindWechatBtn"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1544') : false
              "
              >解除绑定</el-button
            >
          </template>
          <template v-else>未绑定</template>
        </div>
      </div>
      <div class="tem_title">账户信息</div>
      <div class="box">
        <div class="item">
          <span class="title">开户行</span>
          <span>{{ info.bank_name }}</span>
        </div>
        <div class="item">
          <span class="title">银行卡号</span>
          <span>{{ info.bank_account }}</span>
        </div>
        <div class="item">
          <span class="title">支行信息</span>
          <el-input
            v-model="info.bank_branch"
            style="width: 300px; margin-right: 10px"
          ></el-input>
          <el-button
            type="primary"
            :disabled="!info.bank_branch"
            @click="bindCard"
            >与卡号绑定</el-button
          >
        </div>
        <div>
          <span class="title">微信信息</span>
          <el-input
            v-model="info.wx_account"
            style="width: 300px; margin-right: 10px"
          ></el-input>
          <el-button
            type="primary"
            @click="updateDoctorWxAccount"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('441') : false
            "
            >添加</el-button
          >
        </div>
        <div style="margin: 10px 0" class="flex">
          <div>
            <span class="title">显示我的账户</span>
            <span>
              <el-radio-group
                v-model="info.is_open_account"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('967') : false
                "
                @change="setOpenMyAccount"
              >
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </span>
          </div>

          <div v-if="info.is_open_account">
            <span class="title" style="width: 160px">查看账户需要验证码</span>
            <span>
              <el-radio-group
                v-model="info.is_look_account"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1797') : false
                "
                @change="setLookAccount"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
          </div>
        </div>
        <div style="margin: 10px 0">
          <span class="title">显示接诊开方统计</span>
          <span>
            <el-radio-group
              v-model="info.is_open_consult_pre"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('968') : false
              "
              @change="setReceptionPrescriptionStatistics"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div>
          <span class="title">是否开启可提现比例设置</span>
          <span>
            <el-radio-group
              v-model="info.is_cashout_proportion"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('514') : false
              "
              @change="cashoutChange"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div
          style="padding-left: 180px; margin-top: 8px"
          v-if="info.is_cashout_proportion == 1"
        >
          <span>
            <span>比例值</span>
            <span style="margin: 0 20px 0 10px">{{
              info.cashout_proportion
            }}</span>
            <el-button
              type="primary"
              size="mini"
              @click="
                cashout_proportion = undefined;
                cashout = true;
              "
              :disabled="
                module_id_array[0] ? !module_id_array.includes('514') : false
              "
              >修改</el-button
            >
          </span>
        </div>
      </div>
      <!--  -->
      <div class="tem_title">问诊配置</div>
      <div class="box">
        <div>
          <span class="title">电话问诊权限</span>
          <span>
            <el-radio-group
              v-model="info.is_phone_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('781') : false
              "
              @change="updatePhoneConsult"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">预约问诊权限</span>
          <span>
            <el-radio-group
              v-model="info.is_register_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('810') : false
              "
              @change="setRegisterConsult"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">视频问诊权限</span>
          <span>
            <el-radio-group
              v-model="info.is_video_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('440') : false
              "
              @change="videoChange"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0" class="flex">
          <div>
            <span class="title">是否必填病情自述</span>
            <span>
              <el-radio-group
                v-model="info.is_complain"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1128') : false
                "
                @change="setIsComplain"
              >
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </span>
          </div>
          <div v-if="info.is_complain == 1">
            <span class="title">是否必填问诊单</span>
            <span>
              <el-radio-group
                v-model="info.is_inquiry"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1129') : false
                "
                @change="setIsInquiry"
              >
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </span>
          </div>
        </div>
        <div class="bg">
          <div>
            <span class="title">图文问诊</span>
            <span class="gray" style="width: 90px">是否开启咨询</span>
            <el-radio-group
              v-model="info.reception"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('952') : false
              "
              @change="setConsultSwitch(1)"
            >
              <el-radio :label="2">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">新患者问诊费用</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              :min="0"
              :max="9999"
              :precision="0"
              v-model="info.new_reception_price"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setConsultCost"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              >调整</el-button
            >
            <span class="gray" style="width: 130px">是否允许医生修改</span>
            <el-radio-group
              v-model="info.new_reception_edit"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('954') : false
              "
              @change="setAllowDoctorModify"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">老患者问诊费用</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              v-model="info.reception_price"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              :min="0"
              :max="9999"
              :precision="0"
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setConsultCost"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              >调整</el-button
            >
            <span class="gray" style="width: 130px">是否允许医生修改</span>
            <el-radio-group
              v-model="info.reception_edit"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('954') : false
              "
              @change="setAllowDoctorModify"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">服务费比例</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              :min="0"
              :max="1"
              v-model="info.reception_proportion"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setServiceFeeProportion"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
              >调整</el-button
            >
          </div>
        </div>
        <div class="bg">
          <div style="margin: 10px 0">
            <span class="title">电话问诊</span>
            <span class="gray" style="width: 90px">是否开启咨询</span>
            <el-radio-group
              v-model="info.phone_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('952') : false
              "
              @change="setConsultSwitch(1)"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px">
            <span class="title" style="font-weight: 400">问诊费用</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              v-model="info.phone_consult_price"
              :controls="false"
              :min="0"
              :max="9999"
              :precision="0"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setConsultCost"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              >调整</el-button
            >
            <span class="gray" style="width: 130px">是否允许医生修改</span>
            <el-radio-group
              v-model="info.phone_consult_edit"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('954') : false
              "
              @change="setAllowDoctorModify"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">服务费比例</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              :min="0"
              :max="1"
              v-model="info.phone_consult_proportion"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setServiceFeeProportion"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
              >调整</el-button
            >
          </div>
        </div>
        <div class="bg">
          <div style="margin: 10px 0">
            <span class="title">视频问诊</span>
            <span class="gray" style="width: 90px">是否开启咨询</span>
            <el-radio-group
              v-model="info.video_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('952') : false
              "
              @change="setConsultSwitch(1)"
            >
              <el-radio :label="2">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
            <span style="font-weight: 600; margin-left: 50px">视频时长</span>
            <el-input-number
              style="width: 100px; margin: 0 5px 0 16px"
              size="medium"
              v-model="info.consult_time_long"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1130') : false
              "
              :min="0"
              :max="50"
              :precision="0"
            ></el-input-number>
            <span>分钟</span>
            <el-button
              style="margin-left: 10px"
              type="primary"
              size="medium"
              @click="setConsultTimeLong"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1130') : false
              "
              >调整</el-button
            >
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">问诊费用</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              v-model="info.video_consult_price"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              :min="0"
              :max="9999"
              :precision="0"
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setConsultCost"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('953') : false
              "
              >调整</el-button
            >
            <span class="gray" style="width: 130px">是否允许医生修改</span>
            <el-radio-group
              v-model="info.video_consult_edit"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('954') : false
              "
              @change="setAllowDoctorModify"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">服务费比例</span>
            <el-input-number
              style="width: 120px; margin-right: 10px"
              size="medium"
              :min="0"
              :max="1"
              v-model="info.video_consult_proportion"
              :controls="false"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
            ></el-input-number>
            <el-button
              type="primary"
              size="medium"
              @click="setServiceFeeProportion"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('989') : false
              "
              >调整</el-button
            >
          </div>
        </div>
        <!-- 免打扰设置 -->
        <div class="bg">
          <div style="margin: 10px 0">
            <span class="title">免打扰设置</span>
            <span class="gray" style="width: 90px">是否开启</span>
            <el-radio-group
              v-model="info.open_disturb"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('952') : false
              "
              @change="setConsultSwitch(2)"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div style="padding-left: 85px; margin-top: 10px">
            <span class="title" style="font-weight: 400">每日免打扰时段</span>

            <el-time-picker
              style="width: 120px"
              v-model="disturb_start_time"
              :picker-options="{ format: 'HH:mm' }"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
            >
            </el-time-picker>
            <span>&nbsp;~&nbsp;</span>
            <el-time-picker
              style="width: 120px"
              v-model="disturb_end_time"
              :picker-options="{ format: 'HH:mm' }"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
            >
            </el-time-picker>

            <el-button
              type="primary"
              size="medium"
              style="margin-left: 10px"
              @click="setOpenDisturb"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1523') : false
              "
              >调整</el-button
            >
          </div>
        </div>
        <!-- 是否开启极速问诊 -->
        <div class="bg">
          <div style="margin: 10px 0">
            <span class="title">是否开启极速问诊</span>
            <el-radio-group
              v-model="info.open_fast_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1684') : false
              "
              @change="setFastConsult"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>

            <template v-if="info.open_fast_consult == 1">
              <span class="title" style="width: 160px">是否设置为默认医生</span>
              <el-radio-group
                v-model="info.default_fast_consult"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1684') : false
                "
                @change="setFastConsult"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </div>
        </div>
        <!-- 非复诊患者不可咨询 -->
        <div class="bg">
          <div style="margin: 10px 0">
            <span class="title">非复诊患者不可咨询</span>
            <el-radio-group
              v-model="info.follow_consultation"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1747') : false
              "
              @change="setFollowConsultation"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="tem_title">开方配置</div>
      <div class="box">
        <!-- 开方权限 -->
        <div style="margin-top: 10px">
          <span class="title" style="font-size: 18px; margin-bottom: 10px"
            >开方权限</span
          >
          <span>
            <el-radio-group
              v-model="info.is_pre"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1975') : false
              "
              @change="setIsPre"
            >
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </span>
        </div>
        <!-- 诊金设置 -->
        <div style="margin-bottom: 10px; display: flex">
          <div class="title" style="font-size: 18px">诊金设置</div>
          <div>
            <div style="margin-bottom: 10px">
              <span style="font-weight: bold; margin-right: 10px"
                >诊金上限设置</span
              >
              <span>
                <el-radio-group
                  v-model="info.is_consulting_gold"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('677')
                      : false
                  "
                  @change="consultingChange"
                >
                  <el-radio :label="0">关闭</el-radio>
                  <el-radio :label="1">开启</el-radio>
                </el-radio-group>
              </span>
            </div>

            <div
              style="padding-left: 200px"
              v-if="info.is_consulting_gold == 1"
            >
              <span>
                <span>诊金上限</span>
                <span style="margin: 0 20px 0 10px">{{
                  info.consulting_gold
                }}</span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    consulting_gold = undefined;
                    consulting = true;
                  "
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('677')
                      : false
                  "
                  >修改</el-button
                >
              </span>
            </div>

            <div style="margin-bottom: 10px">
              <span style="font-weight: bold; margin-right: 10px"
                >诊金附加到药品金额</span
              >
              <span>
                <el-radio-group
                  v-model="info.gold_join"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1004')
                      : false
                  "
                  @change="setGoldJoin"
                >
                  <el-radio :label="0">不加入</el-radio>
                  <el-radio :label="1">加入</el-radio>
                </el-radio-group>
              </span>
              <span class="gray" style="width: 160px">是否允许医生修改</span>
              <el-radio-group
                v-model="info.gold_join_edit"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1005') : false
                "
                @change="setGoldJoinEdit"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>

            <div style="margin-bottom: 10px">
              <span style="font-weight: bold; margin-right: 10px"
                >开方时是否隐藏诊金</span
              >
              <span>
                <el-radio-group
                  v-model="info.is_show_consulting_gold"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1926')
                      : false
                  "
                  @change="setConsultingGoldHid"
                >
                  <el-radio :label="1">不隐藏</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </span>
            </div>

            <div>
              <span style="font-weight: bold; margin-right: 10px"
                >诊金默认值设置</span
              >
              <span>
                <el-radio-group
                  v-model="info.default_consulting_gold_type"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1927')
                      : false
                  "
                  @input="setDefaultConsultingGold"
                >
                  <el-radio :label="0">免费</el-radio>
                  <div
                    style="display: inline-block"
                    @click="default_consulting_gold_dia = true"
                  >
                    <el-radio :label="-1"
                      >其他
                      <span v-show="info.default_consulting_gold_type"
                        >：{{ info.default_consulting_gold }}元</span
                      >
                    </el-radio>
                  </div>
                </el-radio-group>
              </span>
              <!-- 诊金默认值弹框 -->
              <el-dialog
                title="诊金默认值设置"
                :visible.sync="default_consulting_gold_dia"
                center
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                width="300px"
              >
                <div style="padding: 10px">
                  <span>诊金默认值&nbsp;</span>
                  <el-input-number
                    v-model="default_consulting_gold_num"
                    size="small"
                    :min="1"
                    :precision="0"
                    :controls="false"
                  ></el-input-number>
                </div>
                <span slot="footer">
                  <el-button
                    size="small"
                    @click="
                      () => {
                        default_consulting_gold_dia = false;
                        !Number(info.default_consulting_gold)
                          ? (info.default_consulting_gold_type = 0)
                          : '';
                      }
                    "
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click="setDefaultConsultingGoldFn"
                    >确 定</el-button
                  >
                </span>
              </el-dialog>
            </div>
          </div>
        </div>

        <div style="height: 20px; margin-bottom: 10px">
          <span class="title"
            >诊后管理设置
            <el-tooltip
              effect="light"
              content="关闭后，医生开方时诊后管理将默认关闭，医生可手动开启"
              placement="top"
            >
              <el-button type="text" icon="el-icon-question"></el-button>
            </el-tooltip>
          </span>

          <span>
            <el-radio-group
              v-model="info.open_consult_drug"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1625') : false
              "
              @change="setOpenConsultDrug"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin-top: 16px" class="flex">
          <span class="title">开方页-是否隐藏诊后管理</span>
          <div>
            <div>
              <span class="dis_in">
                <el-radio
                  v-model="info.is_consult_drug"
                  @change="setConsultDrug"
                  :label="1"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('951')
                      : false
                  "
                  >不隐藏</el-radio
                >
              </span>
              <span style="color: #747981"
                >控制医生端服务设置
                -【开方时看不到诊后管理】关闭，医生可修改设置</span
              >
            </div>
            <div style="margin: 3px 0">
              <span class="dis_in">
                <el-radio
                  v-model="info.is_consult_drug"
                  @change="setConsultDrug"
                  :label="0"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('951')
                      : false
                  "
                  >隐藏</el-radio
                >
              </span>
              <span style="color: #747981"
                >控制医生端服务设置
                -【开方时看不到诊后管理】开启，医生可修改设置</span
              >
            </div>
            <div style="margin: 3px 0">
              <span class="dis_in">
                <el-radio
                  @change="setConsultDrug"
                  v-model="info.is_consult_drug"
                  :label="2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('951')
                      : false
                  "
                  >永久隐藏</el-radio
                >
              </span>
              <span style="color: #747981"
                >医生开方时看不到诊后管理，且医生不能修改设置</span
              >
            </div>
            <div>
              <span class="dis_in">
                <el-radio
                  @change="setConsultDrug"
                  v-model="info.is_consult_drug"
                  :label="3"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('951')
                      : false
                  "
                  >永久显示</el-radio
                >
              </span>
              <span style="color: #747981"
                >医生开方时可见诊后管理，且医生不能修改设置</span
              >
            </div>
          </div>
        </div>
        <div style="margin-top: 10px">
          <span class="title">诊后管理费附加到药费</span>
          <span>
            <el-radio-group
              v-model="info.consult_drug_price_in"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1006') : false
              "
              @change="setConsultDrugPriceIn"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
          <span class="gray" style="width: 160px">是否允许医生修改</span>
          <el-radio-group
            v-model="info.consult_drug_price_edit"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1007') : false
            "
            @change="setConsultDrugPriceEdit"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
        <!-- <div style="margin-top: 10px">
          <span class="title">服用次数设置</span>
          <span>
            每日分
            <el-select v-model="info.default_day_num"
                       placeholder="请选择"
                       style="width: 100px; margin: 0 10px"
                       size="small"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1066') : false
              ">
              <el-option v-for="item in [2, 3]"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
            次服用
            <el-button type="primary"
                       size="medium"
                       @click="setTakeDayNum"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1066') : false
              ">保存</el-button>
          </span>
        </div> -->
        <div style="margin-top: 10px">
          <span class="title">是否向患者寄送处方笺</span>
          <span>
            <el-radio-group
              v-model="info.send_print_pre"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1533') : false
              "
              @change="setSendPrintPre"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-top: 10px">
          <span class="title">新标剂量转换设置</span>
          <span>
            <el-radio-group
              v-model="info.national_standard"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1748') : false
              "
              @change="setNationalStandard"
            >
              <el-radio :label="1">开启自动转换新标药材剂量</el-radio>
              <el-radio :label="0">关闭自动转换新标药材剂量</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
      <!--  -->
      <div class="tem_title">医生配置</div>
      <div class="box">
        <div style="margin-bottom: 10px">
          <span class="title">在平台搜不到我</span>
          <span>
            <el-radio-group
              v-model="info.is_open"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1545') : false
              "
              @change="doctorSetupBtn('setIsOpen', 'is_open')"
            >
              <el-radio :label="1">关闭</el-radio>
              <el-radio :label="0">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">允许患者更换药房</span>
          <span>
            <el-radio-group
              v-model="info.change_hospital"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1546') : false
              "
              @change="doctorSetupBtn('setChangeHospital', 'change_hospital')"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">开方时自动带入上次处方</span>
          <span>
            <el-radio-group
              v-model="info.is_prev_pre"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1547') : false
              "
              @change="doctorSetupBtn('setIsPrevPre', 'is_prev_pre')"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">开方后药材保密设置</span>
          <span>
            <el-radio-group
              v-model="info.is_show"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1548') : false
              "
              @change="doctorSetupBtn('setIsShow', 'is_show')"
            >
              <el-radio :label="1">不保密</el-radio>
              <el-radio :label="2">药材保密</el-radio>
              <el-radio :label="0">仅剂量保密</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">开方后自动复诊提醒</span>
          <span>
            <el-radio-group
              v-model="info.is_pre_consult_notice"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1549') : false
              "
              @change="
                doctorSetupBtn('setIsPreConsultNotice', 'is_pre_consult_notice')
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">开方后自动推送随访单</span>
          <span>
            <el-radio-group
              v-model="info.is_pre_visit_notice"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1550') : false
              "
              @change="
                doctorSetupBtn('setIsPreVisitNotice', 'is_pre_visit_notice')
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">邀请患者后自动复诊提醒</span>
          <span>
            <el-radio-group
              v-model="info.is_fav_consult_notice"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1551') : false
              "
              @change="
                doctorSetupBtn('setIsFavConsultNotice', 'is_fav_consult_notice')
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">服用次数设置</span>
          <span>
            每日分
            <el-select
              v-model="info.default_day_num"
              placeholder="请选择"
              style="width: 100px; margin: 0 10px"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1066') : false
              "
            >
              <el-option
                v-for="item in [2, 3]"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            次服用
            <el-button
              type="primary"
              size="medium"
              @click="setTakeDayNum"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1066') : false
              "
              >保存</el-button
            >
          </span>
        </div>
        <div style="margin-bottom: 10px">
          <span class="title">是否开启多处方开方</span>
          <span>
            <el-radio-group
              v-model="info.pre_times"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1067') : false
              "
              @change="setPreTimes"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin-bottom: 10px">
          <span class="title">是否自动回复</span>
          <span>
            <el-radio-group
              v-model="info.open_auto_reply"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1624') : false
              "
              @change="setOpenAutoReply"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin-bottom: 10px" class="flex">
          <span class="title">医生接收短信项目</span>
          <div>
            <div
              v-for="(item, index) in info.list"
              :key="index"
              style="margin-bottom: 5px"
            >
              <span class="gray" style="width: 135px; text-align: left">{{
                item.title
              }}</span>
              <el-radio-group
                v-model="item.status"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('676') : false
                "
                @change="
                  (value) => {
                    return setDoctorSetting(value, item.notice_key, item.title);
                  }
                "
              >
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 10px">
          <span class="title">小歧AI助手</span>
          <span>
            <el-radio-group
              v-model="info.is_ai"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1976') : false
              "
              @change="setIsAi"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
      <!--  -->
      <div class="tem_title">消息配置</div>
      <div class="box">
        <div class="flex">
          <span class="title"> 歧黄助手接收消息项目</span>
          <div>
            <div style="margin-bottom: 5px">
              <span class="gray" style="width: 100px">医生月报</span>
              <el-radio-group
                v-model="info.send_month_report"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('844') : false
                "
                @change="setMonthReportBool"
              >
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div>
          <span class="title">医生开方备注</span>
        </div>
        <div>
          <span class="title" style="font-weight: 400">客服接收</span>
          <el-input
            v-model="info.doc_remark"
            style="width: 300px; margin-right: 10px"
            placeholder="例如：需要给患者开发票"
            maxlength="200"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('755') : false
            "
          ></el-input>
          <el-button
            type="primary"
            size="medium"
            @click="addRemark"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('755') : false
            "
            >添加</el-button
          >
        </div>
        <div style="padding-left: 200px; color: #ff7440; margin-bottom: 10px">
          医生开方后，附加推送此备注信息
        </div>
        <div style="margin: 20px0 10px">
          <span class="title" style="font-weight: 400">药房打印显示</span>
          <el-input
            v-model="info.hospital_print_remark"
            style="width: 300px; margin-right: 10px"
            maxlength="50"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('807') : false
            "
          ></el-input>
          <el-button
            type="primary"
            size="medium"
            @click="addPrintRemark"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('807') : false
            "
            >添加</el-button
          >
        </div>

        <div style="margin: 20px 0 10px">
          <span class="title">药房打印处方当剂量不保密时是否显示颗粒重量</span>
          <span>
            <el-radio-group
              v-model="info.is_show_weight"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2030') : false
              "
              @change="setIsShowWeightBtn"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
      <div class="tem_title">其他配置</div>
      <div class="box">
        <div>
          <span class="title">已绑定云诊所</span>
          <span>{{ info.is_bind_clinic }}</span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">问诊实名</span>
          <span>
            <el-radio-group
              v-model="info.is_consult_auth"
              @change="setConsultAuth(info.is_consult_auth)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1796') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
          <span style="margin-left: 10px; padding-top: 2px"
            >默认平台规则：{{ info.is_consult_auth_str }}</span
          >
        </div>

        <div style="margin: 10px 0">
          <span class="title">处方支付实名</span>
          <span>
            <el-radio-group
              v-model="info.is_pay_auth"
              @change="setIsPayAuth(info.is_pay_auth)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1767') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
          <span style="margin-left: 10px; padding-top: 2px"
            >默认平台规则：{{ info.is_pay_auth_str }}</span
          >
        </div>

        <div style="margin: 10px 0">
          <span class="title">语音转文字</span>
          <span>
            <el-radio-group
              v-model="info.voice_to_words"
              @change="setVoiceToWords(info.voice_to_words)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1798') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">独家处方</span>
          <span>
            <el-radio-group
              v-model="info.is_pre_agr"
              @change="updateDoctorTypeAuth(2, info.is_pre_agr)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('448') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">拍照开方</span>
          <span>
            <el-radio-group
              v-model="info.is_docpic"
              @change="updateDoctorTypeAuth(3, info.is_docpic)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('448') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">线下坐诊设置</span>
          <span>
            <el-radio-group
              v-model="info.is_scheduling"
              @change="updateDoctorTypeAuth(4, info.is_scheduling)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('448') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">医生APP首页显示统计数据</span>
          <span>
            <el-radio-group
              v-model="info.is_show_home_count"
              @change="setIsShowHomeCount"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1622') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">医生APP首页显示已开处方</span>
          <span>
            <el-radio-group
              v-model="info.home_page_pre_show"
              @change="setHomePagePreShow"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2042') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">是否开启推荐商品</span>
          <span>
            <el-radio-group
              v-model="info.open_recommend_goods"
              @change="setOpenRecommendGoods"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1626') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">医生APP处方详情显示费用明细</span>
          <span>
            <el-radio-group
              v-model="info.is_show_cost"
              @change="setlsshowCost"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1623') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">是否开启专属病历服务权限</span>
          <span>
            <el-radio-group
              v-model="info.is_characteristic"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('622') : false
              "
              @change="updateDoctorCharacteristic"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否开启助理账号权限</span>
          <span>
            <el-radio-group
              v-model="info.assistants_power"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('756') : false
              "
              @change="setDoctorAssistantsPower"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否开启人脸识别认证入口</span>
          <span>
            <el-radio-group
              v-model="info.open_face"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1033') : false
              "
              @change="setOpenFace"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否开启多点执业备案入口</span>
          <span>
            <el-radio-group
              v-model="info.open_record"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1034') : false
              "
              @change="setOpenRecord"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否开启接诊时人脸识别</span>
          <span>
            <el-radio-group
              v-model="info.open_face_consult"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1035') : false
              "
              @change="setOpenFaceConsult"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否开启开方时人脸识别</span>
          <span>
            <el-radio-group
              v-model="info.open_face_pre"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1036') : false
              "
              @change="setOpenFacePre"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <!-- <div style="margin: 10px 0">
          <span class="title">是否开启打印第二张处方</span>
          <span>
            <el-radio-group v-model="info.send_print_pre"
                            :disabled="
                module_id_array[0] ? !module_id_array.includes('1032') : false
              "
                            @change="setIsPrevPre">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div> -->
        <!-- <div style="margin: 10px 0">
          <span class="title">是否开启多处方开方</span>
          <span>
            <el-radio-group v-model="info.pre_times"
                            :disabled="
                module_id_array[0] ? !module_id_array.includes('1067') : false
              "
                            @change="setPreTimes">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div> -->
        <div style="margin-top: 10px">
          <span class="title">医生唯一标签</span>
          <span>
            <el-select
              size="medium"
              v-model="info.head_label"
              placeholder="请选择"
              style="width: 200px; margin-right: 10px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1068') : false
              "
              clearable
            >
              <el-option
                v-for="item in only_label"
                :key="item.label_id"
                :label="item.label_name"
                :value="item.label_name"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              size="medium"
              @click="setHeadLabel"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1068') : false
              "
              >保存</el-button
            >
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否可查看医生资质详情</span>
          <span>
            <el-radio-group
              v-model="info.is_certificate"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1131') : false
              "
              @change="setIsCertificate"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">是否显示医生服务标签</span>
          <span>
            <el-radio-group
              v-model="info.is_doctor_label"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1132') : false
              "
              @change="setIsDoctorLabel"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">是否开启医生代付</span>
          <span>
            <el-radio-group
              v-model="info.doctor_pay"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1303') : false
              "
              @change="setDoctorPay"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title">是否可管理患者收货地扯</span>
          <span>
            <el-radio-group
              v-model="info.manage_address"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1532') : false
              "
              @change="setManageAddress"
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
        </div>

        <div style="margin: 10px 0">
          <span class="title"
            >是否展示工作室名称
            <el-tooltip
              class="item"
              effect="light"
              content="开启后，患者端医生详情页、患者端的推送和短信消息、云药房打印的处方笺将展示工作室信息"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <span>
            <el-radio-group
              v-model="info.is_show_office"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1502') : false
              "
            >
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </span>
          <span v-if="info.is_show_office">
            <span class="title" style="margin-left: -80px">工作室名称</span>
            <el-select
              size="medium"
              v-model="info.office_name"
              placeholder="请选择"
              style="width: 200px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1502') : false
              "
              clearable
            >
              <el-option
                v-for="item in office_name_list"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </span>
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="medium"
            @click="setOfficeInfo"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1502') : false
            "
            >保存</el-button
          >
        </div>
        <div style="margin-top: 10px">
          <span class="title">医生客服标签</span>
          <span>
            <el-select
              size="medium"
              v-model="info.customer_service_label"
              placeholder="请选择"
              style="width: 400px; margin-right: 10px"
              multiple=""
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1304') : false
              "
            >
              <el-option
                v-for="item in customer_label"
                :key="item.label_id"
                :label="item.label_name"
                :value="item.label_name"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              size="medium"
              @click="setDoctorServiceLabel"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1304') : false
              "
              >保存</el-button
            >
          </span>
        </div>
        <div style="margin: 10px 0">
          <span class="title">医生从业年限</span>
          <el-input-number
            style="width: 100px"
            size="medium"
            v-model="info.doctor_year"
            :controls="false"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1133') : false
            "
            :min="0"
            :max="99"
            :precision="0"
          ></el-input-number>
          <span style="margin: 0 16px 0 6px">年</span>
          <el-button
            type="primary"
            size="medium"
            @click="setDoctorYear"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1133') : false
            "
            >保存</el-button
          >
        </div>
        <div style="margin-top: 12px">
          <span class="title">医生外显标签</span>
          <el-select
            size="medium"
            v-model="info.doctor_label"
            placeholder="请选择"
            style="width: 400px; margin-right: 10px"
            multiple=""
            :disabled="
              module_id_array[0] ? !module_id_array.includes('817') : false
            "
          >
            <el-option
              v-for="item in view_label"
              :key="item.label_id"
              :label="item.label_name"
              :value="item.label_name"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            size="medium"
            @click="addLabel"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('817') : false
            "
            >保存</el-button
          >
        </div>

        <div style="margin-top: 10px">
          <span class="title">专题设置</span>
          <span>
            {{ info.subject_str }}
            <el-button
              type="primary"
              size="medium"
              @click="setSpecialSubject"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1977') : false
              "
              >编辑</el-button
            >
          </span>
        </div>
      </div>
    </div>

    <!-- 专题弹窗主体 -->
    <el-dialog
      title="专题设置"
      :visible.sync="specialSubjectVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <!-- 专题列表 -->
      <div class="topic-list">
        <el-card
          v-for="(topic, index) in specialSubjectForm"
          :key="index"
          class="topic-item"
        >
          <div class="topic-header">
            <span>专题{{ index + 1 }}</span>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete(index)"
            ></el-button>
          </div>

          <!-- 专题表单 -->
          <el-form
            :model="topic"
            :rules="rules"
            :ref="'topicForm' + index"
            label-width="100px"
          >
            <el-form-item label="专题名称" prop="sub_title">
              <el-input
                v-model="topic.sub_title"
                placeholder="请输入专题名称"
                size="small"
                maxlength="10"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="专题入口图"
              prop="image"
              class="avatar-uploader"
            >
              <UploadImg
                :index="index"
                :f_thumb="topic.image"
                :f_thumb_str="topic.image_str"
                @emitImg="emitImg"
              ></UploadImg>
              <div class="prompt">建议上传538*240</div>
            </el-form-item>

            <el-form-item
              label="专题头图"
              prop="head_image"
              class="avatar-uploader"
            >
              <UploadImg
                :index="index"
                :f_thumb="topic.head_image"
                :f_thumb_str="topic.head_image_str"
                @emitImg="emitHeadImg"
              ></UploadImg>
              <div class="prompt">建议上传538*240</div>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 添加按钮 -->
      <div class="add-action">
        <el-button
          type="text"
          icon="el-icon-plus"
          :disabled="specialSubjectForm.length >= 4"
          @click="handleAdd"
        >
          添加专题
          <span v-if="specialSubjectForm.length >= 4" class="limit-tip"
            >（已达上限）</span
          >
        </el-button>
      </div>

      <!-- 弹窗操作栏 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button
          type="primary"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1978') : false
          "
          @click="handleSubmit"
          :loading="submitting"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置可提现比例弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="cashout"
      width="400px"
      class="other"
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div>
          确定要开启设置可提现比例？ 税后收入，将按比例入账可提现、不可提现。
        </div>
        <div style="margin: 24px 0">
          <span>比例值</span>
          <el-input-number
            v-model="cashout_proportion"
            :min="0"
            :max="0.99"
            :precision="2"
            placeholder="大于等于0,小于1;最多2位小数"
            :controls="false"
            style="margin-left: 10px; width: 240px"
          >
          </el-input-number>
        </div>
        <div style="text-align: center">
          <el-button plain size="medium" @click="cancelProportion"
            >取消</el-button
          >
          <el-button type="primary" size="medium" @click="setProportion"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 设置诊金上限弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="consulting"
      width="400px"
      class=""
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div>确定要开启设置诊金上限？</div>
        <div style="margin: 24px 0">
          <span>诊金上限</span>
          <el-input-number
            v-model="consulting_gold"
            :min="0"
            :max="9999"
            :precision="0"
            placeholder="0 - 9999"
            :controls="false"
            style="margin-left: 10px; width: 240px"
          >
          </el-input-number>
        </div>
        <div style="text-align: center">
          <el-button plain size="medium" @click="cancelProportion"
            >取消</el-button
          >
          <el-button type="primary" size="medium" @click="setDrugPriceSetting"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import doctor from "@/api/doctor";
import common from "@/api/common";
import UploadImg from "@/components/uploadImg/index";
export default {
  name: "Msg",
  components: {
    UploadImg,
  },
  data() {
    return {
      info: {
        deviceid_msg: {},
      },
      cashout: false,
      cashout_proportion: undefined,
      consulting: false,
      consulting_gold: undefined,
      inputVisible: false,
      inputValue: "",
      only_label: [],
      customer_label: [],
      view_label: [],
      office_name_list: [],
      open_disturb: 0,
      disturb_start_time: "",
      disturb_end_time: "",
      default_consulting_gold_dia: false,
      default_consulting_gold_num: undefined,
      // 专题
      specialSubjectVisible: false,
      submitting: false,
      specialSubjectForm: [
        {
          sub_title: "",
          image: "",
          image_str: "",
          head_image: "",
          head_image_str: "",
        },
      ],
      rules: {
        sub_title: [
          { required: true, message: "请输入专题名称", trigger: "blur" },
        ],
        head_image: [
          { required: true, message: "请上传头图", trigger: "blur" },
        ],
        image: [{ required: true, message: "请上传入口图", trigger: "change" }],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    // 解除绑定
    unbindWechatBtn() {
      this.$confirm("确认解除绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const loading = this.$loading();
          common
            .unbindWechat({ doctor_id: this.$route.query.doctor_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("解除成功");
                this.getDetail();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    getDetail() {
      let doctor_id = this.$route.query.doctor_id;
      this.axios
        .post("platform/doctor/doctorItemOther", { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.info = res.data.info;
            this.info.default_consulting_gold_type = !Number(
              this.info.default_consulting_gold
            )
              ? 0
              : -1;
            this.default_consulting_gold_num = Number(
              this.info.default_consulting_gold
            );
            this.info.deviceid_msg.timestamp = res.data.info.deviceid_msg
              .timestamp
              ? dayjs
                  .unix(this.info.deviceid_msg.timestamp)
                  .format("YYYY-MM-DD HH:mm:ss")
              : "";
            this.info.doctor_label = this.info.doctor_label
              ? this.info.doctor_label.split(",")
              : [];
            this.info.customer_service_label = this.info.customer_service_label
              ? this.info.customer_service_label.split(",")
              : [];
            this.disturb_start_time =
              this.info.disturb_start_time == -1
                ? null
                : this.transitionDisturbTtime(this.info.disturb_start_time);
            this.disturb_end_time =
              this.info.disturb_end_time == -1
                ? null
                : this.transitionDisturbTtime(this.info.disturb_end_time);
          }
        });
    },
    transitionDisturbTtime(time) {
      // 转换为式分秒
      let h = parseInt((time / 60 / 60) % 24);
      h = h < 10 ? "0" + h : h;
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      // 作为返回值返回
      return `${h}:${m}`;
    },
    bindCard() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        bank_branch: this.info.bank_branch,
      };
      this.axios
        .post("platform/doctor/saveDoctorBankBranch", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("绑定成功");
            this.getDetail();
          }
        });
    },
    //修改视频权限
    videoChange(value) {
      this.$confirm("确认修改医生视频问诊权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id: this.$route.query.doctor_id,
            is_video_consult: value,
          };
          return this.axios.post("platform/doctor/updateVideoConsult", data);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.getDetail();
        })
        .catch(() => {
          this.getDetail();
        });
    },
    //是否开启问诊自述
    setIsComplain(value) {
      this.info.is_inquiry = 0;
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_complain: value,
      };
      this.axios.post("platform/doctor/setIsComplain", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否必填问诊单
    setIsInquiry(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_inquiry: value,
      };
      this.axios.post("platform/doctor/setIsInquiry", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //修改可提现比例开启关闭
    cashoutChange(value) {
      if (value == 1) {
        this.cashout_proportion = undefined;
        this.cashout = true;
      } else {
        this.$confirm("确定要关闭设置可提现比例？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            let data = {
              doctor_id: this.$route.query.doctor_id,
              is_cashout_proportion: value,
            };
            return this.axios.post(
              "platform/doctor/setDoctorCashoutProportion",
              data
            );
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getDetail();
          })
          .catch(() => {
            this.getDetail();
          });
      }
    },
    //设置可提现比例
    setProportion() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_cashout_proportion: this.info.is_cashout_proportion,
        cashout_proportion: this.cashout_proportion,
      };
      this.axios
        .post("platform/doctor/setDoctorCashoutProportion", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("设置成功");
            this.cashout = false;
            this.getDetail();
          }
        });
    },
    //修改诊金上限开启关闭
    consultingChange(value) {
      if (value == 1) {
        this.consulting_gold = undefined;
        this.consulting = true;
      } else {
        this.$confirm("确定要关闭设置诊金上限？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            let data = {
              doctor_id: this.$route.query.doctor_id,
              is_consulting_gold: 0,
            };
            return this.axios.post("platform/doctor/setDrugPriceSetting", data);
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getDetail();
          })
          .catch(() => {
            this.getDetail();
          });
      }
    },
    //设置诊金上限金额
    setDrugPriceSetting() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_consulting_gold: this.info.is_consulting_gold,
        consulting_gold: this.consulting_gold,
      };
      this.axios
        .post("platform/doctor/setDrugPriceSetting", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("设置成功");
            this.consulting = false;
            this.getDetail();
          }
        });
    },
    // 设置开方时是否隐藏诊金
    setConsultingGoldHid() {
      let parmas = {
        doctor_id: this.$route.query.doctor_id,
        is_show_consulting_gold: this.info.is_show_consulting_gold,
      };
      this.axios
        .post("platform/doctor/consultingGoldHid", parmas)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("设置成功");
            this.getDetail();
          }
        });
    },
    // 设置诊金默认值设置
    setDefaultConsultingGold() {
      if (this.info.default_consulting_gold_type == -1) {
        this.default_consulting_gold_num = this.info.default_consulting_gold;
        this.default_consulting_gold_dia = true;
        return;
      }
      this.default_consulting_gold_num = 0;
      this.setDefaultConsultingGoldFn();
    },
    setDefaultConsultingGoldFn() {
      this.default_consulting_gold_dia = false;
      let parmas = {
        doctor_id: this.$route.query.doctor_id,
        default_consulting_gold: this.default_consulting_gold_num,
      };
      this.axios
        .post("platform/doctor/defaultConsultingGold", parmas)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("设置成功");
            this.getDetail();
          }
        });
    },
    //取消设置
    cancelProportion() {
      this.cashout = false;
      this.consulting = false;
      this.getDetail();
    },
    updateDoctorWxAccount() {
      if (!this.info.wx_account) {
        this.$message.error("请先填写微信信息");
        return false;
      }
      let data = {
        doctor_id: this.$route.query.doctor_id,
        wx_account: this.info.wx_account,
      };
      this.axios
        .post("platform/doctor/updateDoctorWxAccount", data)
        .then((res) => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        });
    },
    //修改专属病历服务权限权限
    updateDoctorCharacteristic(value) {
      this.$confirm("确认修改专属病历服务权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id: this.$route.query.doctor_id,
            is_characteristic: value,
          };
          return this.axios.post(
            "platform/Inquirysheet/updateDoctorCharacteristic",
            data
          );
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.getDetail();
        })
        .catch(() => {
          this.getDetail();
        });
    },
    //医生短信通知设置
    setDoctorSetting(value, notice_key, title) {
      this.$confirm(`确认修改${title}的接收状态吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id: this.$route.query.doctor_id,
            notice_key: notice_key,
            status: value,
          };
          return this.axios.post("platform/doctor/setDoctorSetting", data);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.getDetail();
        })
        .catch(() => {
          this.getDetail();
        });
    },
    //设置医生助理账号权限
    setDoctorAssistantsPower(value) {
      this.$confirm("确认修改医生助理账号权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let loading = this.$loading();
          let data = {
            doctor_id: this.$route.query.doctor_id,
            assistants_power: value,
          };
          this.axios
            .post("platform/doctor/setDoctorAssistantsPower", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功!");
              }
              this.getDetail();
              loading.close();
            });
        })
        .catch(() => {
          this.getDetail();
        });
    },
    //修改医生电话问诊权限
    updatePhoneConsult(value) {
      this.$confirm("确认修改医生电话问诊权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id: this.$route.query.doctor_id,
            is_phone_consult: value,
          };
          this.axios
            .post("platform/doctor/updatePhoneConsult", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功!");
                this.getDetail();
              }
            });
        })
        .catch(() => {
          this.getDetail();
        });
    },
    // 设置预约问诊权限
    setRegisterConsult(value) {
      this.$confirm("确认修改医生预约问诊权限吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            doctor_id: this.$route.query.doctor_id,
            is_register_consult: value,
          };
          this.axios
            .post("platform/doctor/setRegisterConsult", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功!");
                this.getDetail();
              }
            });
        })
        .catch(() => {
          this.getDetail();
        });
    },
    // 设置医生开方备注
    addRemark() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        doc_remark: this.info.doc_remark,
      };
      this.axios.post("platform/doctor/setDoctorRemark", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 设置药房打印显示
    addPrintRemark() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        hospital_print_remark: this.info.hospital_print_remark,
      };
      this.axios
        .post("platform/doctor/setHospitalPrintRemark", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //设置月报
    setMonthReportBool(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        send_month_report: value,
      };
      this.axios
        .post("platform/doctor/doctorMonthReportBool", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //开方时-是否隐藏诊后管理
    setConsultDrug() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_consult_drug: this.info.is_consult_drug,
      };
      this.axios.post("platform/doctor/setConsultDrug", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //问诊咨询开关设置
    setConsultSwitch(type) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        reception: this.info.reception,
        phone_consult: this.info.phone_consult,
        video_consult: this.info.video_consult,
      };
      if (type === 2) {
        data.open_disturb = this.info.open_disturb;
      }
      console.log(data);
      this.axios.post("platform/doctor/setConsultSwitch", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 是否极速问诊
    setFastConsult() {
      let parmas = {
        doctor_id: this.$route.query.doctor_id,
        open_fast_consult: this.info.open_fast_consult,
        default_fast_consult: this.info.default_fast_consult,
      };
      doctor.setFastConsult(parmas).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否允许医生修改
    setAllowDoctorModify() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        reception_edit: this.info.reception_edit,
        new_reception_edit: this.info.new_reception_edit,
        phone_consult_edit: this.info.phone_consult_edit,
        video_consult_edit: this.info.video_consult_edit,
      };
      this.axios
        .post("platform/doctor/setAllowDoctorModify", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //问诊费用设置
    setConsultCost() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        reception_price: this.info.reception_price,
        new_reception_price: this.info.new_reception_price,
        phone_consult_price: this.info.phone_consult_price,
        video_consult_price: this.info.video_consult_price,
      };
      this.axios.post("platform/doctor/setConsultCost", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 免打扰设置
    setOpenDisturb() {
      if (this.disturb_start_time) {
        if (!this.disturb_end_time) {
          this.$message.warning("请选择时间段");
          return;
        }
      }
      if (this.disturb_end_time) {
        if (!this.disturb_start_time) {
          this.$message.warning("请选择时间段");
          return;
        }
      }

      if (
        this.disturb_start_time == this.disturb_end_time &&
        this.disturb_start_time &&
        this.disturb_end_time
      ) {
        this.$message.warning("开始时间不能等于结束时间");
        return;
      }
      let disturb_start_time = !this.disturb_start_time
        ? -1
        : this.transitionTiem(this.disturb_start_time);
      let disturb_end_time = !this.disturb_end_time
        ? -1
        : this.transitionTiem(this.disturb_end_time);
      console.log(disturb_start_time, disturb_end_time);
      let params = {
        doctor_id: this.$route.query.doctor_id,
        disturb_start_time,
        disturb_end_time,
      };
      doctor.setOpenDisturb(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("调整成功");
          this.getDetail();
        }
      });
    },
    transitionTiem(time) {
      let h = time.substr(0, 2);
      let s = time.substr(3, 2);
      return h * 3600 + s * 60;
    },
    //设置视频时长
    setConsultTimeLong() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        consult_time_long: this.info.consult_time_long,
      };
      this.axios
        .post("platform/doctor/setConsultTimeLong", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //是否开启我的账户
    setOpenMyAccount(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_open_account: value,
      };
      this.axios.post("platform/doctor/setOpenMyAccount", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 查看账户需要验证码
    setLookAccount(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_look_account: value,
      };
      this.axios.post("/platform/doctor/setLookAccount", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否开启接诊开方统计
    setReceptionPrescriptionStatistics(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_open_consult_pre: value,
      };
      this.axios
        .post("platform/doctor/setReceptionPrescriptionStatistics", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //设置服务费比例
    setServiceFeeProportion() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        reception_proportion: this.info.reception_proportion,
        phone_consult_proportion: this.info.phone_consult_proportion,
        video_consult_proportion: this.info.video_consult_proportion,
      };
      this.axios
        .post("platform/doctor/setServiceFeeProportion", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //诊金附加到药品金额
    setGoldJoin(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        gold_join: value,
      };
      this.axios.post("platform/doctor/setGoldJoin", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //允许医生修改诊金附加到药品金额
    setGoldJoinEdit(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        gold_join_edit: value,
      };
      this.axios.post("platform/doctor/setGoldJoinEdit", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //诊后管理费附加到药费
    setConsultDrugPriceIn(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        consult_drug_price_in: value,
      };
      this.axios
        .post("platform/doctor/setConsultDrugPriceIn", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    // 诊后管理设置
    setOpenConsultDrug(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        open_consult_drug: val,
      };
      common.setOpenConsultDrug(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    //允许医生修改诊后管理费附加到药费
    setConsultDrugPriceEdit(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        consult_drug_price_edit: value,
      };
      this.axios
        .post("platform/doctor/setConsultDrugPriceEdit", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //是否打印第二张处方
    // setIsPrevPre(value) {
    //   let data = {
    //     doctor_id: this.$route.query.doctor_id,
    //     send_print_pre: value
    //   };
    //   this.axios.post('platform/doctor/setIsPrevPre', data).then((res) => {
    //     if (res.code == 0) {
    //       this.$message.success('保存成功');
    //     }
    //     this.getDetail();
    //   });
    // },
    //是否开启人脸识别认证
    setOpenFace(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        open_face: value,
      };
      this.axios.post("platform/doctor/setOpenFace", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否开启多点执业备案
    setOpenRecord(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        open_record: value,
      };
      this.axios.post("platform/doctor/setOpenRecord", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否开启接诊人脸识别
    setOpenFaceConsult(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        open_face_consult: value,
      };
      this.axios
        .post("platform/doctor/setOpenFaceConsult", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //是否开启开方人脸识别
    setOpenFacePre(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        open_face_pre: value,
      };
      this.axios.post("platform/doctor/setOpenFacePre", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //服用次数设置
    setTakeDayNum() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        default_day_num: this.info.default_day_num,
      };
      this.axios.post("platform/doctor/setTakeDayNum", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 是否向患者寄送处方笺
    setSendPrintPre() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        send_print_pre: this.info.send_print_pre,
      };
      this.axios.post("platform/doctor/setSendPrintPre", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
        }
        this.getDetail();
      });
    },
    // 开方权限
    async setIsPre() {
      // 如果关闭开方权限,需要二次确认
      if (!this.info.is_pre) {
        try {
          await this.$confirm(
            "关闭后当前医生将不可开方，同时将不展示拍照开方、独家处方、面对面开方。确定需要关闭吗？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          );
        } catch (err) {
          // 取消操作,恢复原值
          this.info.is_pre = 1;
          return;
        }
      }

      // 调用接口修改开方权限
      const data = {
        doctor_id: this.$route.query.doctor_id,
        is_pre: this.info.is_pre,
      };

      try {
        const res = await this.axios.post("platform/doctor/setIsPre", data);
        if (res.code === 0) {
          this.$message.success("修改成功");
          await this.getDetail();
        }
      } catch (err) {
        this.$message.error("修改失败");
        // 发生错误时恢复原值
        this.info.is_pre = !this.info.is_pre;
      }
    },
    // 设置新标药材剂量修改确认弹框是否开启
    setNationalStandard() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        national_standard: this.info.national_standard,
      };
      doctor.setNationalStandard(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
        }
        this.getDetail();
      });
    },
    // 是否开启多处方
    setPreTimes(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        pre_times: value,
      };
      this.axios.post("platform/doctor/setPreTimes", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 设置自动回复
    setOpenAutoReply(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        open_auto_reply: val,
      };
      common.setOpenAutoReply(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 小歧AI助手
    setIsAi(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_ai: val,
      };
      this.axios.post("platform/doctor/setIsAi", params).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    // 药房打印处方当剂量不保密时是否显示颗粒重量
    setIsShowWeightBtn(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_show_weight: val,
      };
      this.axios.post("platform/doctor/setIsShowWeight", params).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否可查看医生资质详情
    setIsCertificate(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_certificate: value,
      };
      this.axios.post("platform/doctor/setIsCertificate", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否显示医生服务标签
    setIsDoctorLabel(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_doctor_label: value,
      };
      this.axios.post("platform/doctor/setIsDoctorLabel", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否开启医生代付
    setDoctorPay(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        doctor_pay: value,
      };
      this.axios.post("platform/doctor/setDoctorPay", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //是否可管理患者收货地扯
    setManageAddress(value) {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        manage_address: value,
      };
      this.axios.post("platform/doctor/setManageAddress", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
        }
        this.getDetail();
      });
    },
    //医生从业年限
    setDoctorYear() {
      let data = {
        doctor_id: this.$route.query.doctor_id,
        doctor_year: this.info.doctor_year,
      };
      this.axios.post("platform/doctor/setDoctorYear", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //医生唯一标签
    setHeadLabel() {
      let tag_data = {};
      if (this.info.head_label) {
        tag_data = this.only_label.find((ele) => {
          return ele.label_name == this.info.head_label;
        });
      }
      let data = {
        doctor_id: this.$route.query.doctor_id,
        head_label: tag_data.label_name ? tag_data.label_name : "",
        label_id: tag_data.label_id ? tag_data.label_id : "",
      };
      this.axios.post("platform/doctor/setHeadLabel", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //医生客服标签设置
    setDoctorServiceLabel() {
      let id_arr = [];
      this.info.customer_service_label.map((item) => {
        let data = this.customer_label.find((ele) => {
          return ele.label_name == item;
        });
        if (data) {
          id_arr.push(data.label_id);
        }
      });
      let data = {
        doctor_id: this.$route.query.doctor_id,
        customer_service_label: this.info.customer_service_label.toString(),
        label_id: id_arr.toString(),
      };
      this.axios
        .post("platform/doctor/setDoctorServiceLabel", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
          this.getDetail();
        });
    },
    //添加医生外显标签
    addLabel() {
      if (this.info.doctor_label.length > 3) {
        this.$message.error("最多添加3个医生外显标签");
        return false;
      }
      let id_arr = [];
      this.info.doctor_label.map((item) => {
        let data = this.view_label.find((ele) => {
          return ele.label_name == item;
        });
        if (data) {
          id_arr.push(data.label_id);
        }
      });
      let data = {
        doctor_id: this.$route.query.doctor_id,
        doctor_label: this.info.doctor_label.toString(),
        label_id: id_arr.toString(),
      };
      this.axios.post("platform/doctor/setDoctorLabel", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //设置医生的工作室信息
    setOfficeInfo() {
      if (this.info.is_show_office && !this.info.office_name) {
        this.$message.error("请选择工作室");
        return false;
      }
      let data = {
        doctor_id: this.$route.query.doctor_id,
        is_show_office: this.info.is_show_office,
        office_name: this.info.office_name,
      };
      this.axios.post("platform/Doctor/setOfficeInfo", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //获取医生所有标签列表
    getDoctorTag() {
      this.axios.post("platform/Doctor/getDoctorLabel").then((res) => {
        if (res.code == 0) {
          this.customer_label = res.data.customer_label;
          this.only_label = res.data.only_label;
          this.view_label = res.data.view_label;
        }
      });
    },
    //获取名医工作室列表
    getOfficeNameList() {
      this.axios.post("platform/Doctor/getOfficeNameList").then((res) => {
        if (res.code == 0) {
          this.office_name_list = res.data.office_name_list;
        }
      });
    },
    // 药房设置
    doctorSetupBtn(name, key) {
      let doctor_id = this.$route.query.doctor_id;
      let params = {
        doctor_id,
        [key]: this.info[key],
      };
      doctor[name](params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("保存成功");
        }
        this.getDetail();
      });
    },
    //修改医生拍照、视频 分享 开方权限
    updateDoctorTypeAuth(type, open_type) {
      let params = {
        doctor_ids: this.$route.query.doctor_id,
        type,
        open_type,
      };
      common.updateDoctorTypeAuth(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 设置问诊是否需要实名
    setConsultAuth(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_consult_auth: val,
      };
      common.setConsultAuth(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },

    // 设置处方支付是否需要实名
    setIsPayAuth(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_pay_auth: val,
      };
      common.setIsPayAuth(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },

    // 设置处方支付是否开启语音转文字
    setVoiceToWords(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        voice_to_words: val,
      };
      common.setVoiceToWords(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 设置医生APP首页显示统计数据
    setIsShowHomeCount(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_show_home_count: val,
      };
      common.setIsShowHomeCount(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 设置医生APP首页显示已开处方
    setHomePagePreShow(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        home_page_pre_show: val,
      };
      common.homePagePreShow(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 设置推荐商品
    setOpenRecommendGoods(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        open_recommend_goods: val,
      };
      common.setOpenRecommendGoods(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 医生APP处方详情显示费用明细
    setlsshowCost(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        is_show_cost: val,
      };
      common.setlsshowCost(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },
    // 设置非复诊患者不可咨询
    setFollowConsultation(val) {
      let params = {
        doctor_id: this.$route.query.doctor_id,
        follow_consultation: val,
      };
      doctor.setFollowConsultation(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDetail();
        }
      });
    },

    // 专题设置
    setSpecialSubject() {
      let params = {
        doctor_id: this.$route.query.doctor_id,
      };
      this.axios
        .post("platform/doctor/doctorSpecialSubject", params)
        .then((res) => {
          let { data, code } = res;
          if (code == 0) {
            this.specialSubjectForm = data.list;
            this.specialSubjectVisible = true;
          }
        });
    },
    // 添加专题
    handleAdd() {
      if (this.specialSubjectForm.length >= 4) return;
      this.specialSubjectForm.push({
        sub_title: "",
        image: "",
        image_str: "",
        head_image: "",
        head_image_str: "",
      });
    },

    // 删除专题
    handleDelete(index) {
      this.$confirm("确定删除该专题吗？", "提示", {}).then(() => {
        this.specialSubjectForm.splice(index, 1);
      });
    },
    // 专题入口图
    emitImg(data, index) {
      this.specialSubjectForm[index].image = data.pic;
      this.specialSubjectForm[index].image_str = data.path;
    },
    // 专题头图
    emitHeadImg(data, index) {
      this.specialSubjectForm[index].head_image = data.pic;
      this.specialSubjectForm[index].head_image_str = data.path;
    },

    // 提交保存
    handleSubmit() {
      // 验证所有表单
      const validateResults = this.specialSubjectForm.map((_, index) => {
        return new Promise((resolve) => {
          this.$refs[`topicForm${index}`][0].validate((valid) => {
            resolve(valid);
          });
        });
      });

      Promise.all(validateResults).then((results) => {
        if (results.every((valid) => valid)) {
          this.submitting = true;

          let params = {
            doctor_id: this.$route.query.doctor_id,
            list: this.specialSubjectForm,
          };
          this.axios
            .post("platform/doctor/updateDoctorSpecialSubject", params)
            .then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success("保存成功");
                this.specialSubjectVisible = false;
                this.submitting = false;
                this.getDetail();
              }
            })
            .catch(() => {
              this.submitting = false;
            });
        } else {
          this.$message.warning("请完善专题信息");
        }
      });
    },

    // 取消操作
    handleCancel() {
      this.specialSubjectVisible = false;
    },
  },
  created() {
    this.getDetail();
    this.getDoctorTag();
    this.getOfficeNameList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 24px 24px 24px 32px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
  text-align: left;
}
.tem_title {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 10px;
}
.title {
  color: #333;
  font-weight: 600;
  width: 230px;
  display: inline-block;
  text-align: right;
  margin-right: 20px;
}
.gray {
  color: #747981;
  display: inline-block;
  width: 70px;
  text-align: right;
  margin-right: 10px;
}
.black {
  color: #333333;
}
.item {
  margin-bottom: 12px;
}
.dialogbox {
  padding: 20px;
  text-align: left;
}
.dis_in {
  display: inline-block;
  width: 100px;
}
.box {
  border: solid 1px #cfcece;
  padding: 14px 0;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
  div {
    width: 33%;
  }
}
.bg {
  background: #ededed;
  width: 800px;
  padding: 10px 0;
  margin-bottom: 12px;
}
.topic-list {
  //   max-height: 60vh;
  //   overflow-y: auto;
  //   padding-right: 10px;

  .topic-item {
    margin-bottom: 15px;

    .topic-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #eee;
    }
  }
}

.add-action {
  text-align: center;
  margin: 15px 0;

  .limit-tip {
    color: #f56c6c;
    margin-left: 5px;
  }
}

.avatar-uploader {
  ::v-deep .el-form-item__content {
    height: 130px;
  }

  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
  }
}
</style>
